module.exports = __webpack_public_path__ + "img/rules_9.a7d8881b.png";